import { Box, Button, Modal, Typography, useTheme, CircularProgress } from '@mui/material';
import React from 'react';
import { colorTheme } from 'theme';

export interface IDialogProps {
  isDisabled?: boolean;
  open: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  handleConfirm?: () => Promise<void>; // modify type here
  handleCancel?: () => void;
}

const YesNoModal = (props: IDialogProps): JSX.Element => {
  const {
    title, onClose, isDisabled, open, handleConfirm,
  } = props;
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',

          bgcolor: 'background.paper',
          boxShadow: 24,
          py: 5,
          px: 5,
          width: '20%',
          borderRadius: 5,
        }}
      >
        <Typography variant="h5" component="h2" sx={{ textAlign: 'center' }}>
          {title}
        </Typography>
        <Box
          sx={{
            pt: 3,
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              mt: 3,
              mb: 2,
              bgcolor: colors.gray[900],
              borderRadius: 2,
              py: 1.5,
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              style={{ fontSize: '12px', color: colors.primaryBg[700] }}
            >
              No
            </Typography>
          </Button>
          <Box
            sx={{
              pt: 3,
            }}
          ></Box>
          <Button
            onClick={handleConfirm}
            endIcon={isDisabled ? <CircularProgress size={15} /> : null}
            disabled={isDisabled}
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              py: 1.5,
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              style={{ fontSize: '12px' }}
            >
              Yes
            </Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default YesNoModal;
